export const imageMimeType = /image\/(png|jpg|jpeg)/i;
